import style from "./style.scss";

import { useState, useRef, useEffect } from "preact/hooks"; // Changed import
import { h } from "preact"; // Changed import

const AccordionItem = ({ question, answer, index, open = false }) => {
  const [isOpen, setIsOpen] = useState(open);
  const panelRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (panelRef.current) {
      setMaxHeight(panelRef.current.scrollHeight);
    }
  }, [isOpen]);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div class={style.accordionItem}>
      <button
        class={style.accordionHeader}
        aria-expanded={isOpen}
        aria-controls={`panel-${index}`}
        onClick={toggleAccordion}
      >
        <span class={style.question}>{question}</span>
        <span class={style.toggle} />
      </button>
      <div
        class={style.accordionPanel}
        id={`panel-${index}`}
        aria-hidden={!isOpen}
        style={{ maxHeight: isOpen ? `${maxHeight}px` : "0px" }}
        ref={panelRef}
      >
        <div class={style.contentWrapper}>{answer}</div>
      </div>
    </div>
  );
};

const Accordion = ({ items }) => {
  return (
    <div class={style.accordion}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          question={item.question}
          answer={item.answer}
          id={index}
          open={item.open}
        />
      ))}
    </div>
  );
};

export default Accordion;
